const extensionToAssetType = {
  ".dcm": "DICOMStudy",
  ".set": "Set",
  ".gltf": "Surface",
  ".glb": "Surface",
  ".stl": "Surface",
  ".vol": "Volume",
  ".nii.gz": "Surface",
  ".off": "PointCloud",
  ".pnt": "PointCloud",
};

export default class FileUploadInfo {
  constructor(files, analyzedFileInfo) {
    this.files = files || [];
    this.uploadedFiles = [];

    this.assetType = null;
    this.isDicom = false;
    this.hasDicomDir = false;
    this.dicomFilesAndUids = {};
    this.missingFilesSummary = "";
    this.anonymizeSupported = true;
    this.isStl = false;
    this.isPly = false;
    this.patientAsset = null;
    this.assetGroupId = null;

    this.PatientID = null;
    this.PatientName = null;
    this.PatientBirthDate = null;
    this.PatientSex = null;

    let merged = Object.assign(this, analyzedFileInfo);
    merged._detectAssetType();
    return merged;
  }
  setUploadedFiles(uploadedFiles) {
    this.uploadedFiles = uploadedFiles;
    const expectedFiles = Object.keys(this.dicomFilesAndUids);
    if (expectedFiles.length != uploadedFiles.length) {
      const uploadedInstanceUids = uploadedFiles.map((file) => {
        const slashPos = file.id.lastIndexOf("/");
        return file.id.substring(slashPos + 1).replace(".dcm", "");
      });
      const missingFiles = Object.entries(this.dicomFilesAndUids)
        .filter((entry) => {
          return !uploadedInstanceUids.includes(entry[1]);
        })
        .map((entry) => entry[0]);

      this.missingFilesSummary =
        missingFiles.length <= 3
          ? missingFiles.join(", ")
          : missingFiles.slice(0, 3).join(", ") + ", ...";
    }
  }
  addUploadedDicomFileInfo(uploadedFileInfos) {
    uploadedFileInfos
      .filter((i) => i.instanceUid !== "")
      .forEach((i) => {
        this.dicomFilesAndUids[i.filename] = i.instanceUid;
      });
  }
  isMissingFilesReferencedInDicomDir() {
    return this.files.length < Object.keys(this.dicomFilesAndUids).length;
  }
  _detectAssetType() {
    if (this.isDicom) {
      // DICOM is detected outside of this class
      this.assetType = "DICOMStudy";
    } else if (this._containsSurfaceFiles(".stl")) {
      this.assetType = "Surface";
      this.isStl = true;
    } else if (this._containsSurfaceFiles(".ply")) {
      this.assetType = "Surface";
      this.isPly = true;
    } else this.assetType = this._mapFileExtension();
  }
  _mapFileExtension() {
    for (let file of this.files) {
      const fileName = file.file.name;
      let extension = fileName.endsWith(".gz")
        ? fileName.replace(/^.*(\.[^/.]+\.gz)$/, "$1")
        : fileName.replace(/^.*(\.[^/.]+)$/, "$1");
      const assetType = extensionToAssetType[extension];
      if (assetType) {
        return assetType;
      }
    }
    return "Unknown";
  }
  _containsSurfaceFiles(extension) {
    return (
      this.files.filter((file) => {
        const fileName = file.file.name;
        return fileName.toLowerCase().includes(extension);
      }).length > 0
    );
  }
}
